import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getMedicinesAction,
  deleteMedicineAction,
} from "../../../store/actions/MedicinesAction";
import swal from "sweetalert";
import Loader from "../Common/Loader";

const Medicine = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const medicines = useSelector((state) => state.medicines.medicines.medicines);
  const numRows = useSelector((state) => state.medicines.medicines.num_rows);
  console.log("object >> medicines", useSelector((state) => state.medicines));

  const [searchQueries, setSearchQueries] = useState({
    medicine_code: "",
    medicine_name: "",
    display_name_en: "",
    medicine_type_text: "",
    medicine_status: "",
    cgst_sgst_price: "",
  });

  const [sortField, setSortField] = useState("medicine_code");
  const [sortOrder, setSortOrder] = useState("asc");
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [activeSearchField, setActiveSearchField] = useState("");
  const [activeSearchKeyword, setActiveSearchKeyword] = useState("");

  useEffect(() => {
    const fetchMedicines = async () => {
      setLoading(true);
      setError("");
      try {
        await fetchMedicinesFromServer();
      } catch (err) {
        console.error("Failed to fetch medicines:", err);
        setError("Failed to load medicines.");
      } finally {
        setLoading(false);
      }
    };

    fetchMedicines();
  }, [dispatch]);

  const fetchMedicinesFromServer = async (
    search_by = "",
    search_keyword = "",
    pagination = true,
    pageid = 0,
    sort_by = sortField,
    sort_order = sortOrder
  ) => {
    try {
      await dispatch(
        getMedicinesAction(pagination, pageid, search_by, search_keyword, sort_by, sort_order)
      );
    } catch (err) {
      console.error("Failed to fetch medicines:", err);
      setError("Failed to load medicines.");
    }
  };

  const handleSearch = (e, field) => {
    const keyword = e.target.value;
    
    // Clear all search queries first, then set the current field
    const clearedQueries = {
      medicine_code: "",
      medicine_name: "",
      display_name_en: "",
      medicine_type_text: "",
      medicine_status: "",
      cgst_sgst_price: "",
    };
    
    const updatedQueries = { ...clearedQueries, [field]: keyword };
    setSearchQueries(updatedQueries);
    setCurrentPage(0); // Reset to first page on search

    // Track active search
    setActiveSearchField(field);
    setActiveSearchKeyword(keyword);
    fetchMedicinesFromServer(field, keyword, true, 0, sortField, sortOrder);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchMedicinesFromServer(
      activeSearchField,
      activeSearchKeyword,
      true,
      page,
      sortField,
      sortOrder
    );
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);
    setCurrentPage(0); // Reset to first page on new sort
    fetchMedicinesFromServer(activeSearchField, activeSearchKeyword, true, 0, field, order);
  };

  const handleEdit = (medicine) => {
    navigate(`/medicine/update-medicine/${medicine.medicine_id}`, {
      state: { medicine },
    });
  };

  const totalPages = Math.ceil(numRows / rowsPerPage);

  const handleDelete = (medicineId) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this medicine!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          await dispatch(deleteMedicineAction({ medicine_id: medicineId }));
          // Refresh the current page after deletion
          await fetchMedicinesFromServer(
            activeSearchField,
            activeSearchKeyword,
            true,
            currentPage,
            sortField,
            sortOrder
          );
        } catch (err) {
          setError("Failed to delete medicine");
          console.error("Delete failed:", err);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const paginatedData = medicines; // Server already returns paginated data

  return (
    <>
      <div className="row mb-3">
        <div className="col-12 text-end">
          <Link
            to="/medicine/add-medicine"
            className="btn btn-primary btn-rounded"
          >
            + Add Medicine
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              {error && <div className="text-danger mb-2">{error}</div>}
              {loading ? (
                <div className="text-center my-5">
                  <Loader size="lg" />
                </div>
              ) : (
                <>
                  {/* ✅ Responsive Table */}
                  <div className="table-responsive">
                    <table className="table table-striped mb-4">
                      <thead className="table-light">
                        <tr>
                          <th onClick={() => handleSort("medicine_code")} style={{ cursor: "pointer" }}>
                            Code{" "}
                            {sortField === "medicine_code" &&
                              (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.medicine_code}
                              onChange={(e) => handleSearch(e, "medicine_code")}
                              onClick={(e) => e.stopPropagation()}
                              placeholder="Search Code"
                            />
                          </th>
                          <th onClick={() => handleSort("medicine_name")} style={{ cursor: "pointer" }}>
                            Admin Name (English){" "}
                            {sortField === "medicine_name" &&
                              (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.medicine_name}
                              onChange={(e) => handleSearch(e, "medicine_name")}
                              onClick={(e) => e.stopPropagation()}
                              placeholder="Search Name"
                            />
                          </th>
                          <th onClick={() => handleSort("display_name_en")} style={{ cursor: "pointer" }}>
                          Display Name (English){" "}
                            {sortField === "display_name_en" &&
                              (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.display_name_en}
                              onChange={(e) =>
                                handleSearch(e, "display_name_en")
                              }
                              onClick={(e) => e.stopPropagation()}
                              placeholder="Search English Name"
                            />
                          </th>
                          <th onClick={() => handleSort("medicine_type_text")} style={{ cursor: "pointer" }}>
                            Type{" "}
                            {sortField === "medicine_type_text" &&
                              (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.medicine_type_text}
                              onChange={(e) => handleSearch(e, "medicine_type_text")}
                              onClick={(e) => e.stopPropagation()}
                              placeholder="Search Type"
                            />
                          </th>
                          <th onClick={() => handleSort("medicine_status")} style={{ cursor: "pointer" }}>
                            Status{" "}
                            {sortField === "medicine_status" &&
                              (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.medicine_status}
                              onChange={(e) => handleSearch(e, "medicine_status")}
                              onClick={(e) => e.stopPropagation()}
                              placeholder="Search Status"
                            />
                          </th>
                          <th onClick={() => handleSort("cgst_sgst_price")} style={{ cursor: "pointer" }}>
                            Price{" "}
                            {sortField === "cgst_sgst_price" && (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.cgst_sgst_price}
                              onChange={(e) => handleSearch(e, "cgst_sgst_price")}
                              onClick={(e) => e.stopPropagation()}
                              placeholder="Search Price"
                            />
                          </th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData?.map((medicine) => (
                          <tr key={medicine.medicine_id}>
                            <td>{medicine.medicine_code}</td>
                            <td>{medicine.medicine_name}</td>
                            <td>{medicine.display_name_en}</td>
                            <td>{medicine.medicine_type_text}</td>
                            <td>
                              <span
                                className={`badge px-3 py-1 rounded-pill text-white ${
                                  medicine.medicine_status.toLowerCase() === "active"
                                    ? "bg-success"
                                    : "bg-danger"
                                }`}
                              >
                                {medicine.medicine_status}
                              </span>
                            </td>
                            <td>{medicine.cgst_sgst_price || "-"}</td>
                            <td>
                              <div className="d-flex justify-content-around">
                                <span
                                  className="edit me-3"
                                  onClick={() => handleEdit(medicine)}
                                  style={{ cursor: "pointer" }}
                                  title="Edit Medicine"
                                >
                                  <i className="fa fa-pencil-alt text-success"></i>
                                </span>
                                <span
                                  className="delete me-2"
                                  onClick={() => handleDelete(medicine.medicine_id)}
                                  style={{ cursor: "pointer" }}
                                  title="Delete Medicine"
                                >
                                  <i className="fa fa-trash text-danger"></i>
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                        {paginatedData?.length === 0 && (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No medicines found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* ✅ Pagination */}
                  <div
                    className="pagination-wrapper"
                    style={{
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "20px",
                      flexWrap: "wrap",
                      flexDirection: "column", // Show message above the buttons
                    }}
                  >
                    <div>
                      Showing {medicines?.length === 0 ? 0 : currentPage * rowsPerPage + 1} to{" "}
                      {Math.min((currentPage + 1) * rowsPerPage, numRows)} of {numRows} entries
                    </div>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", justifyContent: "center" }}>
                      <button
                        // onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                        onClick={() => handlePageChange(Math.max(currentPage - 1, 0))}
                        disabled={currentPage === 0}
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          color: "#000",
                          cursor: currentPage === 0 ? "not-allowed" : "pointer",
                          opacity: currentPage === 0 ? 0.5 : 1,
                        }}
                      >
                        &lt;
                      </button>
                      {(() => {
                        const pages = [];
                        const maxPagesToShow = 5;
                        const startPage = Math.max(
                          0,
                          Math.min(currentPage - 2, totalPages - maxPagesToShow)
                        );
                        const endPage = Math.min(startPage + maxPagesToShow, totalPages);

                        if (startPage > 0) {
                          pages.push(
                            <button
                              key={0}
                              onClick={() => handlePageChange(0)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                color: "#000",
                                cursor: "pointer",
                              }}
                            >
                              1
                            </button>
                          );
                          if (startPage > 1) {
                            pages.push(
                              <span
                                key="dots1"
                                style={{ padding: "6px 12px", userSelect: "none" }}
                              >
                                ...
                              </span>
                            );
                          }
                        }

                        for (let i = startPage; i < endPage; i++) {
                          const isActive = currentPage === i;
                          pages.push(
                            <button
                              key={i}
                              onClick={() => handlePageChange(i)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: isActive ? "#007bff" : "#fff",
                                color: isActive ? "#fff" : "#000",
                                cursor: "pointer",
                              }}
                            >
                              {i + 1}
                            </button>
                          );
                        }

                        if (endPage < totalPages) {
                          if (endPage < totalPages - 1) {
                            pages.push(
                              <span
                                key="dots2"
                                style={{ padding: "6px 12px", userSelect: "none" }}
                              >
                                ...
                              </span>
                            );
                          }
                          pages.push(
                            <button
                              key={totalPages - 1}
                              onClick={() => handlePageChange(totalPages - 1)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                color: "#000",
                                cursor: "pointer",
                              }}
                            >
                              {totalPages}
                            </button>
                          );
                        }

                        return pages;
                      })()}
                      <button
                        // onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
                        onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages - 1))}
                        disabled={currentPage === totalPages - 1}
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          color: "#000",
                          cursor: currentPage === totalPages - 1 ? "not-allowed" : "pointer",
                          opacity: currentPage === totalPages - 1 ? 0.5 : 1,
                        }}
                      >
                        &gt;
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Medicine;
